import React from 'react';
import { Carousel } from 'antd';

const melaImageContext = require.context(
  '../../../../Assets/Linkages/SpaceOutreachFilm/LahoreScienceMela2025',
  false,
  /\.jpg$/i,
);

const melaImages = melaImageContext.keys().sort().map((key) => {
  const image = melaImageContext(key);
  return image.default || image;
});

const LahoreScienceMela2025 = () => (
  <section
    className="film-international-debut film-international-debut--grey"
    aria-labelledby="lahore-science-mela-title"
  >
    <div className="film-international-debut-inner">
      <div className="film-international-debut-copy">
        <p className="section-eyebrow">LAHORE SCIENCE MELA · 26 OCTOBER 2025</p>
        <h2 id="lahore-science-mela-title">Science Meets Storytelling at Lahore Science Mela 2025</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          During the Lahore Science Mela, organized by the Khwarizmi Science Society (خوارزمی سائنس
          سوسائٹی), a special screening of Jahan Aur Bhi Hain — Beyond the Blue drew a packed audience
          at Crescent Model School, Lahore, on October 26, 2025. Pakistan’s first space-driven climate
          telefilm delivers science through compelling storytelling, portraying the threat of
          cloudbursts and environmental crises while emphasizing the vital role of space science and
          technology in predicting and understanding these challenges.
        </p>
        <p>
          Produced by the National Center of GIS and Space Applications (NCGSA), Institute of Space
          Technology, in collaboration with Beaconhouse National University (BNU) and LockDown
          Productions, the telefilm captivated audiences with its narrative-driven approach,
          inspiring curiosity, fostering scientific awareness, and showcasing how storytelling can
          make complex environmental issues both accessible and impactful.
        </p>
      </div>

      <Carousel
        className="film-international-debut-carousel"
        autoplay
        autoplaySpeed={3000}
        pauseOnHover
        dots
        effect="fade"
      >
        {melaImages.map((src, index) => (
          <figure key={src}>
            <img src={src} alt={`Beyond the Blue screening at Lahore Science Mela ${index + 1}`} loading="lazy" />
          </figure>
        ))}
      </Carousel>
    </div>
  </section>
);

export default LahoreScienceMela2025;
